import React from 'react';
import propTypes from '../../../node_modules/prop-types/index.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { CardWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var Card = function Card(_ref) {
  var children = _ref.children,
      customStyle = _ref.customStyle,
      centered = _ref.centered;
  var theme = useTheme();

  var _safeCustomStyle = safeCustomStyle(customStyle),
      cardStyle = _safeCustomStyle.cardStyle;

  var content = children && React.Children.map(children, function (child) {
    if (!child || !child.type) {
      return child;
    }

    return /*#__PURE__*/React.cloneElement(child, {
      centered: centered
    });
  });
  return /*#__PURE__*/React.createElement(CardWrapper, {
    cardStyle: cardStyle,
    centered: centered,
    theme: theme
  }, content);
};

process.env.NODE_ENV !== "production" ? Card.propTypes = {
  /** Force entire card to be centered */
  centered: propTypes.bool,

  /** children */
  children: propTypes.node.isRequired,

  /** Style overrides */
  customStyle: propTypes.shape({
    cardStyle: propTypes.object
  })
} : void 0;
Card.defaultProps = {
  centered: false,
  customStyle: {
    cardStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? Card.displayName = 'Card' : void 0;

export default Card;
